import { render } from "./composeView.vue?vue&type=template&id=6657d091"
import script from "./composeView.vue?vue&type=script&lang=js"
export * from "./composeView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__